class HamburgerMenuButton extends HTMLElement {
  connectedCallback() {
    const targetId = this.getAttribute("for");
    const menuDrawer = document.getElementById(targetId);
    this.menuDrawerButton = this.getElementsByTagName("button")[0];

    if (!menuDrawer) {
      console.error(`Menu drawer with id "${targetId}" not found.`);
      return;
    }

    if (!this.menuDrawerButton) {
      console.error(
        "Hamburger Menu element is missing a child button element."
      );
      return;
    }

    this.menuDrawerButton.addEventListener("click", () => {
      const isOpen = menuDrawer.toggle();
      this.menuDrawerButton.setAttribute("aria-expanded", isOpen);
    });
  }

  updateIconState(menuDrawerOpenState) {
    this.menuDrawerButton.setAttribute("aria-expanded", menuDrawerOpenState);
  }
}

if (!customElements.get("hamburger-menu-button"))
  customElements.define("hamburger-menu-button", HamburgerMenuButton);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleMenuEscapeKey = this.handleMenuEscapeKey.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.focusableElements = this.querySelectorAll("a, button");
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.updateVisibility();
    return this.isOpen;
  }

  open() {
    this.isOpen = true;
    this.updateVisibility();
  }

  close() {
    this.isOpen = false;
    this.updateVisibility();
  }

  updateVisibility() {
    this.setAttribute("aria-hidden", !this.isOpen);
    this.updateFocusableState();

    this.dispatchEvent(
      new CustomEvent("menuVisability", {
        detail: this.isOpen,
        bubbles: true,
        composed: true,
      })
    );

    if (this.isOpen) {
      // Add click-outside event listener
      // Add key press event listener
      // Artficial delay the addition of the listener to avoid bubbling issues
      setTimeout(() => {
        document.addEventListener("click", this.handleOutsideClick);
        document.addEventListener("keydown", this.handleMenuEscapeKey);
        document.addEventListener("scroll", this.handleScroll);
        this.addEventListener("click", this.handleLinkClick);
      }, 0);
    } else {
      // Remove click-outside event listener
      // Remove key press event listener
      document.removeEventListener("click", this.handleOutsideClick);
      document.removeEventListener("keydown", this.handleMenuEscapeKey);
      document.removeEventListener("scroll", this.handleScroll);
      this.removeEventListener("click", this.handleLinkClick);
    }
  }

  updateFocusableState() {
    this.focusableElements.forEach((el) => {
      el.setAttribute("tabindex", this.isOpen ? "0" : "-1");
    });
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  handleMenuEscapeKey(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
    }
  }

  handleLinkClick(event) {
    const target = event.target;

    // Check if the clicked element is an <a> tag or inside an <a> tag
    if (target.tagName === "A" || target.closest("a")) {
      this.close();
    }
  }

  handleScroll() {
    if (this.isOpen) {
      this.close();
    }
  }
}

if (!customElements.get("menu-drawer"))
  customElements.define("menu-drawer", MenuDrawer);

document.addEventListener("DOMContentLoaded", () => {
  const hamburgerMenuButton = document.querySelector("hamburger-menu-button");
  const menuDrawer = document.querySelector("menu-drawer");

  menuDrawer.addEventListener("menuVisability", (evt) => {
    hamburgerMenuButton.updateIconState(evt.detail);
  });
});
